import { landingCopy } from './copy';

/**
 * The landing footer: the brand motif, placeholder navigation links, and a copyright line.
 *
 * The links point at in-page placeholders for now; real destinations replace them later.
 *
 * @returns The footer element.
 */
export function LandingFooter(): React.JSX.Element {
  const year = new Date().getFullYear();

  return (
    <footer className="gm-landing__footer">
      <span>
        © {year} Greasemap · {landingCopy.footerTagline}
      </span>

      <nav className="gm-landing__footer-links" aria-label="Footer">
        {landingCopy.footerLinks.map((link) => (
          <a key={link.label} className="gm-landing__footer-link" href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>
    </footer>
  );
}
